// Folha "Instalar em 2 passos" para Android/Chrome quando o navegador ainda
// não disparou o beforeinstallprompt. Seta pulsando aponta o ⋮ (canto superior).
export default function FolhaInstalarDoisPassos({ aoFechar }: { aoFechar: () => void }) {
  const passos = [
    { icone: 'ri-more-2-fill', texto: 'Toque em ⋮ no canto de cima do Chrome.' },
    {
      icone: 'ri-smartphone-line',
      texto: 'Escolha "Instalar aplicativo" (ou "Adicionar à tela inicial").',
    },
  ];

  return (
    <div className="fixed inset-0 z-[95] flex items-end justify-center bg-black/50 p-4 sm:items-center">
      <div className="w-full max-w-sm overflow-hidden rounded-3xl bg-white p-6 animate-modal-pop">
        <div className="flex items-start justify-between gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
            <i className="ri-download-2-line text-xl" />
          </span>
          <button
            type="button"
            onClick={aoFechar}
            aria-label="Fechar"
            className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-400 transition-colors hover:bg-background-100 hover:text-foreground-700"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <h3 className="mt-4 text-lg font-bold text-foreground-950">Instalar em 2 passos</h3>

        <ol className="mt-5 space-y-4">
          {passos.map((p, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary-600">
                <i className={p.icone} />
              </span>
              <p className="pt-1.5 text-sm leading-relaxed text-foreground-800">{p.texto}</p>
            </li>
          ))}
        </ol>

        <div className="mt-4 flex items-center justify-end gap-2 text-primary-500">
          <span className="text-xs font-medium text-foreground-500">Toque em ⋮ lá em cima</span>
          <span className="animate-seta-guia flex h-6 w-6 items-center justify-center">
            <i className="ri-arrow-right-up-line text-2xl" />
          </span>
        </div>

        <button
          type="button"
          onClick={aoFechar}
          className="mt-6 w-full cursor-pointer whitespace-nowrap rounded-xl bg-primary-500 px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
        >
          Entendi
        </button>
      </div>
    </div>
  );
}